var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.833 0.333252H2.16634C1.42997 0.333252 0.833008 0.970007 0.833008 1.75547V12.2444C0.833008 13.0298 1.42997 13.6666 2.16634 13.6666H17.833C18.5694 13.6666 19.1663 13.0298 19.1663 12.2444V1.75547C19.1663 0.970007 18.5694 0.333252 17.833 0.333252V0.333252ZM9.99967 8.19441L2.30967 1.22214H17.6897L9.99967 8.19441ZM1.66634 1.80547L6.68684 6.35738L1.66634 12.1245V1.80547ZM7.32242 6.93365L9.7298 9.11632C9.80759 9.18685 9.90363 9.22214 9.99967 9.22214C10.0957 9.22214 10.1917 9.18685 10.2695 9.11632L12.6769 6.93365L17.7644 12.7777H2.23497L7.32242 6.93365ZM13.3125 6.35738L18.333 1.80547V12.1245L13.3125 6.35738Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.ac777775aed535fc032cbd89152a6cb8.svg";
export { ForwardRef as ReactComponent };